(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BrowserFS"));
	else if(typeof define === 'function' && define.amd)
		define(["BrowserFS"], factory);
	else if(typeof exports === 'object')
		exports["Doppio"] = factory(require("BrowserFS"));
	else
		root["Doppio"] = factory(root["BrowserFS"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/